"use strict";
module.exports = {
    'v1.user.register': 'supplierGateway',
    'v1.user.writeUser': 'supplierGateway',
    'v1.user.editUser': 'supplierGateway',
    'v1.user.changePassword': 'supplierGateway',
    'v1.user.verify': 'supplierGateway',
    'v1.user.disable': 'supplierGateway',
    'v1.user.enable': 'supplierGateway',
    'v1.user.forgotPassword': 'supplierGateway',
    'v1.user.resetPassword': 'supplierGateway',
    'v1.user.resolveToken': 'supplierGateway',
    'v1.user.changeActiveOrganization': 'supplierGateway',
    'v1.user.endImpersonation': 'supplierGateway',
    'v1.user.login': 'supplierGateway',
    'v1.user.socialLogin': 'supplierGateway',
    'v1.user.me': 'supplierGateway',
    'v1.user.upsert': 'supplierGateway',
    'v1.user.upsertWhenEmpty': 'supplierGateway',
    'v1.user.updateWhenEmpty': 'supplierGateway',
    'v1.user.update': 'supplierGateway',
    'v1.categoryTree.writeCategoryTree': 'supplierGateway',
    'v1.categoryTree.upsert': 'supplierGateway',
    'v1.categoryTree.upsertWhenEmpty': 'supplierGateway',
    'v1.categoryTree.updateWhenEmpty': 'supplierGateway',
    'v1.categoryTree.update': 'supplierGateway',
    'v1.organization.createSupplierAndOrganisation': 'supplierGateway',
    'v1.organization.publishOnQvanti': 'supplierGateway',
    'v1.organization.unpublishOnQvanti': 'supplierGateway',
    'v1.organization.setExternalFortnoxKeysForOrganization': 'supplierGateway',
    'v1.organization.upsert': 'supplierGateway',
    'v1.organization.upsertWhenEmpty': 'supplierGateway',
    'v1.organization.updateWhenEmpty': 'supplierGateway',
    'v1.organization.update': 'supplierGateway',
    'v1.shopConfig.resolveConfigForSubdomain': 'supplierGateway',
    'v1.shopConfig.writeShopConfig': 'supplierGateway',
    'v1.shopConfig.writeNavbarConfig': 'supplierGateway',
    'v1.shopConfig.changeLandingPage': 'supplierGateway',
    'v1.shopConfig.upsert': 'supplierGateway',
    'v1.shopConfig.upsertWhenEmpty': 'supplierGateway',
    'v1.shopConfig.updateWhenEmpty': 'supplierGateway',
    'v1.shopConfig.update': 'supplierGateway',
    'v1.alert.raiseAlert': 'supplierGateway',
    'v1.alert.closeAlert': 'supplierGateway',
    'v1.alert.upsert': 'supplierGateway',
    'v1.alert.upsertWhenEmpty': 'supplierGateway',
    'v1.alert.updateWhenEmpty': 'supplierGateway',
    'v1.alert.update': 'supplierGateway',
    'v1.ofcInSupplierGateway.upsert': 'supplierGateway',
    'v1.ofcInSupplierGateway.upsertWhenEmpty': 'supplierGateway',
    'v1.ofcInSupplierGateway.updateWhenEmpty': 'supplierGateway',
    'v1.ofcInSupplierGateway.update': 'supplierGateway',
    'v1.supplier-gatewayEventsource.cleanUpOldEvents': 'supplierGateway',
    'v1.supplier-gatewayEventsource.undoEvent': 'supplierGateway',
    'v1.supplier-gatewayEventsource.reEmit': 'supplierGateway',
};
